import { useBreakpoints } from "../../../constants/constants";
import { useGetPageFromPath } from "../../../utils/customHooks/genericHooks";

import { SERVER_NAMES } from "components/Nav/Drawers/RightDrawer/FlightDebugger/SERVER_NAMES";
import { getScaleFromWidthForLargeScreens } from "./dashboardPagesContentUtils";
import { DashboardPagesContentStyles } from "./DashboardPagesContentStyles";
import useContainerDimensions from "utils/useContainerDimensions";
import {
  GlobalPopupMenuResponsiveStyles,
  GlobalResponsiveStyles,
} from "components/Dashboard/styles/getDashboardCardsResponsiveStyles";
import ErrorBoundary from "components/SimpleComponents/Errors/ErrorBoundary";
import { useLocation } from "react-use";
import { Navigate } from "react-router-dom";
import { useCustomerKey } from "utils/customHooks/useCustomerKey";
import LoadingIndicatorDashboardPages from "../LoadingIndicatorDashboardPages";
import AnimationFromClickedTileToHubletView from "./AnimationFromClickedTileToHubletView";
import HubletPage from "../../HubletPage/HubletPage";
import { TakingSnapshotToastIndicator } from "pages/SnapshotsPage/SnapshotsCSVUploader";
import { useDetectIsTakingSnapshot } from "pages/SnapshotsPage/SnapshotElementButton";
import { DashboardPagesMisconfiguredWarning } from "./DashboardPagesMisconfiguredWarning";
import { TilesTimelinePages } from "./DashboardPagesSections/TilesTimelinePages";
import { useFlightConfig } from "components/DataGetter/FlightConfig/useFlightConfig";

function DashboardPagesContent(): React.JSX.Element {
  const { pathname, search } = useLocation();

  const { isGroupTilesPage, isHubletPage } = useGetPageFromPath();

  const [
    {
      general: { tileWidthMultiplier: tileWidthConfig },
    },
  ] = useFlightConfig();
  const [ref, dimensions] = useContainerDimensions();

  const scale = getScaleFromWidthForLargeScreens(dimensions.width);
  const { isDesktopXlOrLarger } = useBreakpoints();
  const searchParams = new URLSearchParams(search);
  const urlWorkScheduleConfigId = searchParams.get("workSchedule");

  useDetectIsTakingSnapshot();
  const ckey = useCustomerKey();

  if (isGroupTilesPage && urlWorkScheduleConfigId == undefined) {
    // if no work schedule param redirect to schedule page for section
    const redirectLink = pathname?.replace("dashboard", "schedule");
    // storybook-cypress url is /iframe.html
    if (redirectLink !== "/iframe.html") {
      return (
        <Navigate
          to={`${
            redirectLink === "/iframe.html"
              ? `/${ckey}/dashboard?workSchedule=1`
              : redirectLink
          }`}
        />
      );
    }
  }
  return (
    <DashboardPagesContentStyles
      // updating dimensions is costly so avoid it when not needed
      ref={isDesktopXlOrLarger ? ref : null}
      className="dashboardPageContent"
      data-server-names={[SERVER_NAMES.askrShifts]}
      data-component-name={"Dashboard Page"}
      $scale={isDesktopXlOrLarger ? scale : 1}
      $isHubletPage={isHubletPage}
      $tileWidthConfig={tileWidthConfig}
    >
      <DashboardPagesMisconfiguredWarning />
      {isDesktopXlOrLarger ? (
        <GlobalPopupMenuResponsiveStyles {...{ $scale: scale }} />
      ) : null}
      <GlobalResponsiveStyles {...{ $scale: scale }} />
      <ErrorBoundary small={true} id="LoadingIndicatorDashboardPages">
        <LoadingIndicatorDashboardPages />
      </ErrorBoundary>
      <AnimationFromClickedTileToHubletView />
      {isHubletPage ? (
        <ErrorBoundary id="HubletPage">
          <HubletPage />
        </ErrorBoundary>
      ) : (
        <TilesTimelinePages />
      )}
      <TakingSnapshotToastIndicator />
    </DashboardPagesContentStyles>
  );
}

export default DashboardPagesContent;
